<div class="bg-white p-1 p-md-4 overflow-auto">
    @if (!loadedError) {
    <h3 class="text-center font-weight-bold">
        {{ 'web.payments_transactions' | translate }}
    </h3>
    @if (data && !getNoData) {
    <table class="table">
        <thead>
            <tr>
                <th scope="col">{{ 'web.date' | translate }}</th>
                <th scope="col">{{ 'web.package' | translate }}</th>
                <th scope="col" class="text-center">{{ 'web.period' | translate }}</th>
                <th scope="col" class="text-center">{{ 'web.valid_to' | translate }}</th>
                <th scope="col" class="text-right">{{ 'web.price' | translate }}</th>
                <th scope="col">&nbsp;</th>
            </tr>
        </thead>
        <tbody>
            @for (transaction of data | keys; track $index) {
            <tr>
                <td>{{ transaction.value.completed[0].created_at | livDate : 'datetime3' }}</td>
                <td>
                    {{ transaction.value.completed[0].product.permission.permission_name | translate }}
                    @if (transaction.value.completed[0].user.trial === 1) {
                    <div class="table-sport__cell--live app-word-nowrap ml-sm-2 ng-tns-c59-375 ng-star-inserted">
                        Trial
                    </div>
                    }
                </td>
                <th scope="row " class="text-center">
                    {{ 'web.user_dashboard_' + transaction.value.completed[0].product.subscription_type | translate }}
                </th>
                <td [class.--expired]="transaction.value.completed[0].user.isExpired" class="text-center">
                    {{ transaction.value.completed[0].user.valid_to | livDate : 'date' }}
                </td>
                <td class="text-right">
                    {{ transaction.value.completed[0].session_data.data.object.amount_total / 100 | number : '1.2' }}
                    {{ transaction.value.completed[0].session_data.data.object.currency }}
                </td>
                <td class="text-right">
                    <a
                        href="/payment/portal?lang={{ lang }}&customer={{
                            transaction.value.completed[0].session_data.data.object.customer
                        }}"
                        >{{ 'web.manage_transactions' | translate }}</a
                    >
                </td>
            </tr>
            }
        </tbody>
    </table>
    } @else {
    <div class="branch-error text-center mt-4">
        <div class="branch-error__child">
            <i class="fas fa-exclamation-circle fa-4x"></i>
            <h2>{{ 'web.no_data' | translate }}</h2>
            <p class="mb-6">{{ 'web.no_transaction_found' | translate }}</p>
        </div>
    </div>
    } } @else {
    <div class="branch-error text-center">
        <div class="branch-error__child">
            <i class="fas fa-exclamation-circle fa-4x"></i>
            <h2>{{ 'web.data_error' | translate }}</h2>
            <p class="mb-6">{{ 'web.error_data_load' | translate }}</p>
        </div>
    </div>
    }
    <ng-template #error>
        <div class="branch-error text-center">
            <div class="branch-error__child">
                <i class="fas fa-exclamation-circle fa-4x"></i>
                <h2>{{ 'web.data_error' | translate }}</h2>
                <p class="mb-6">{{ 'web.error_data_load' | translate }}</p>
            </div>
        </div>
    </ng-template>
</div>
